// English translations keyed by the Dutch source text. Add pap/es dictionaries the same way.
export const EN_TEXT = {
 "Les": "Lesson",
 "Kind": "Child",
 "Maand": "Month",
 "Aantal lessen": "Number of lessons",
 "Eerste les": "First lesson",
 "Totaal": "Total",
 "Lestegoed": "Credit",
 "Te betalen": "Amount due",
 "Veilige lokale betaling. Je plek is pas definitief na een bevestigde betaling.": "Safe local payment. Your seat is only confirmed after a confirmed payment.",
 "Boeking niet gevonden.": "Booking not found.",
 "Afrekenen": "Checkout",
 "De reservering is verlopen. De plek is vrijgegeven.": "The reservation has expired. The seat has been released.",
 "Je plek wordt nog": "Your seat is held for another",
 "vastgehouden.": ".",
 "Deze boeking is al betaald.": "This booking has already been paid.",
 "Deze reservering is vrijgegeven.": "This reservation has been released.",
 "Opnieuw boeken": "Book again",
 "Betaling niet gevonden.": "Payment not found.",
 "TESTMODUS": "TEST MODE",
 "Sentoo betaling (gesimuleerd)": "Sentoo payment (simulated)",
 "Er zijn nog geen Sentoo-gegevens ingesteld. Kies hieronder de uitkomst van deze testbetaling.": "No Sentoo credentials have been set up yet. Choose the outcome of this test payment below.",
 "Betaling gelukt": "Payment successful",
 "Betaling mislukt": "Payment failed",
 "Bekijk resultaat": "View result",
 "De plek is gereserveerd. Je ontvangt een bevestiging en betaalbewijs per e-mail.": "The seat is reserved. You will receive a confirmation and receipt by email.",
 "De plek was niet meer beschikbaar. Het bedrag is als lestegoed op je account gezet.": "The seat was no longer available. The amount has been added to your account as credit.",
 "Er is niets afgeschreven en er is geen plek gereserveerd. Je kunt het opnieuw proberen zolang de reservering geldig is.": "Nothing was charged and no seat was reserved. You can try again while the reservation is valid.",
 "Naar mijn boekingen": "Go to my bookings",
 "Opnieuw proberen": "Try again",
 "Deze betaallink is ongeldig.": "This payment link is invalid.",
 "Maandbetaling": "Monthly payment",
 "Betaal vóór de eerste les van de maand. Onbetaalde plekken worden bij de eerste les automatisch vrijgegeven.": "Pay before the first lesson of the month. Unpaid seats are released automatically at the first lesson.",
 "Betalen met Sentoo": "Pay with Sentoo",
 "Bevestigen met lestegoed": "Confirm with credit",
 "Betaling gelukt!": "Payment successful!",
 "Betaling wordt verwerkt…": "Processing payment…",
 "Lestegoed gebruiken": "Use credit",
 "Status: betaald": "Status: paid",
 "Status: niet meer te betalen": "Status: can no longer be paid",
 "Volledig pakket": "Full package",
 "lessen": "lessons",
 "Niet aanwezig": "Absent",
 "Les zoeken": "Find a lesson",
 "Nog geen geplande lessen.": "No lessons scheduled yet.",
 "Vind een les": "Find a lesson",
 "Voeg je eerste kind toe om lessen te boeken.": "Add your first child to book lessons.",
 "Kind toevoegen": "Add child",
 "Toevoegen": "Add",
 "Betalen": "Pay",
 "Reeks stoppen": "Stop series",
 "Annuleren": "Cancel",
 "Nog geen boekingen.": "No bookings yet.",
 "Kinderen": "Children",
 "Komende lessen": "Upcoming lessons",
 "Openstaande maandbetalingen": "Outstanding monthly payments",
 "Kind toegevoegd": "Child added",
 "Les annuleren? Je ontvangt lestegoed.": "Cancel lesson? You will receive credit.",
 "Geannuleerd – lestegoed ontvangen": "Cancelled – credit received",
 "Geannuleerd": "Cancelled",
 "Deze wekelijkse reeks stoppen? Er worden geen nieuwe maandbetalingen meer verstuurd.": "Stop this weekly series? No new monthly payments will be sent.",
 "Reeks gestopt": "Series stopped",
 "Beschikbaar lestegoed": "Available credit",
 "Datum": "Date",
 "Omschrijving": "Description",
 "Bedrag": "Amount",
 "Nog geen betalingen.": "No payments yet.",
 "Bonnummer": "Receipt number",
 "Betaald": "Paid",
 "Overzicht": "Overview",
 "Boekingen & aanwezigheid": "Bookings & attendance",
 "Betaalbewijzen": "Receipts",
 "Alle tijden in Aruba-tijd (AST, UTC−4).": "All times in Aruba time (AST, UTC−4).",
 "Naam": "Name",
 "Nu betalen": "Pay now",
 "Aanwezig": "Present",
 "Wacht op betaling": "Awaiting payment",
 "Betaallink verstuurd": "Payment link sent",
 "Vrijgegeven": "Released",
 "Gepland": "Scheduled",
 "Gegeven": "Held",
 "Docent no-show": "Teacher no-show",
 "Geslaagd": "Succeeded",
 "Mislukt": "Failed",
 "In behandeling": "Pending",
 "Goedgekeurd": "Approved",
 "Afgewezen": "Rejected",
 "Actief": "Active",
 "Gearchiveerd": "Archived",
 "Nog niets om te tonen.": "Nothing to show yet.",
 "Les starten": "Start lesson",
 "Nog geen ingeschreven kinderen": "No children enrolled yet",
 "Geen lessen.": "No lessons.",
 "Titel": "Title",
 "Beschrijving": "Description",
 "Telefoonnummers, e-mailadressen, links en social media zijn niet toegestaan.": "Phone numbers, email addresses, links and social media are not allowed.",
 "Prijs per kind per les (AWG)": "Price per child per lesson (AWG)",
 "Duur (minuten)": "Duration (minutes)",
 "Roostertype": "Schedule type",
 "+ Datum toevoegen": "+ Add date",
 "Tijden in Aruba-tijd (AST, UTC−4).": "Times in Aruba time (AST, UTC−4).",
 "Les opslaan": "Save lesson",
 "Nieuwe les": "New lesson",
 "Je kunt lessen publiceren zodra je aanmelding is goedgekeurd door ons team.": "You can publish lessons once your application has been approved by our team.",
 "Bewerken": "Edit",
 "Materiaal": "Material",
 "Nog geen lessen.": "No lessons yet.",
 "Profiel opslaan": "Save profile",
 "Profielfoto": "Profile photo",
 "Documenten": "Documents",
 "Alleen zichtbaar voor het Onskola-team.": "Only visible to the Onskola team.",
 "Alleen lessen die daadwerkelijk zijn gegeven (op basis van aanwezigheid) tellen mee. Uitbetaling gebeurt maandelijks door Onskola.": "Only lessons that actually took place (based on attendance) count. Onskola pays out monthly.",
 "Status:": "Status:",
 "Deze les annuleren? Alle ingeschreven ouders ontvangen automatisch lestegoed.": "Cancel this lesson? All enrolled parents automatically receive credit.",
 "Les geannuleerd": "Lesson cancelled",
 "Les opgeslagen": "Lesson saved",
 "Klas / leerjaar": "Grade / year",
 "Losse les": "Single lesson",
 "Wekelijkse reeks (per maand)": "Weekly series (per month)",
 "Cursusblok (pakket)": "Course block (package)",
 "Materiaal geüpload": "Material uploaded",
 "Mijn lessen": "My lessons",
 "Les bewerken": "Edit lesson",
 "Identiteitsbewijs": "ID document",
 "Diploma('s)": "Diploma(s)",
 "Verklaring omtrent gedrag": "Certificate of good conduct",
 "Profiel opgeslagen": "Profile saved",
 "Nog niet geüpload": "Not uploaded yet",
 "Gegeven lessen": "Lessons held",
 "Netto uitbetaling": "Net payout",
 "Nog geen gegeven lessen.": "No lessons held yet.",
 "Lessen & aanwezigheid": "Lessons & attendance",
 "Profiel & documenten": "Profile & documents",
 "Inkomsten": "Earnings",
 "Je account is goedgekeurd.": "Your account has been approved.",
 "Je aanmelding wordt beoordeeld. Upload je documenten in het tabblad Profiel.": "Your application is being reviewed. Upload your documents in the Profile tab.",
 "Docentendashboard": "Teacher dashboard",
 "Lessen": "Lessons",
 "Komend": "Upcoming",
 "Afgelopen": "Past",
 "Vak": "Subject",
 "Schooltype": "School type",
 "Lestaal": "Language",
 "Lesvorm": "Format",
 "Bruto": "Gross",
 "Platformcommissie": "Platform commission",
 "Commissie": "Commission",
 "Netto": "Net",
 "Geüpload": "Uploaded",
 "Archiveren": "Archive",
 "Activeren": "Activate",
 "loyaliteit": "loyalty",
 "plekken bezet": "seats taken",
 "Alle": "All",
 "Goedkeuren": "Approve",
 "Afwijzen": "Reject",
 "Nog geen documenten geüpload": "No documents uploaded yet",
 "Geen aanmeldingen.": "No applications.",
 "Kies ouder": "Choose parent",
 "Opslaan": "Save",
 "Nu controleren": "Check now",
 "Melding wanneer een kind dat 2 of meer opeenvolgende maanden bij een docent boekte, stopt met boeken bij die docent.": "Alert when a child who booked with a teacher for 2 or more consecutive months stops booking with that teacher.",
 "Afgehandeld": "Resolved",
 "Afhandelen": "Resolve",
 "Nieuwe testimonial": "New testimonial",
 "Foto uploaden": "Upload photo",
 "Commissie & annulering": "Commission & cancellation",
 "Max. kinderen per lesvorm": "Max. children per format",
 "Eilanden": "Islands",
 "Aanmeldingen open": "Open applications",
 "Actieve lessen": "Active lessons",
 "Betaalde boekingen": "Paid bookings",
 "Ouders": "Parents",
 "Open alerts": "Open alerts",
 "Maandelijkse omzet": "Monthly revenue",
 "Betalingen": "Payments",
 "Ontvangen (Sentoo)": "Received (Sentoo)",
 "Lestegoed gebruikt": "Credit used",
 "Commissie (gegeven lessen)": "Commission (lessons held)",
 "Netto docenten": "Net to teachers",
 "Status bijgewerkt": "Status updated",
 "Sessie annuleren? Ingeschreven ouders ontvangen lestegoed.": "Cancel session? Enrolled parents receive credit.",
 "Lestegoed bijgewerkt": "Credit updated",
 "Geen alerts.": "No alerts.",
 "Geboekt in": "Booked in",
 "Uitbetalingen per docent": "Payouts per teacher",
 "Markeer als betaald": "Mark as paid",
 "Uitbetaald": "Paid out",
 "Naam (bijv. Mw. Reyes)": "Name (e.g. Mrs. Reyes)",
 "Rol (bijv. ouder van een HAVO-leerling)": "Role (e.g. parent of a HAVO student)",
 "Instellingen opgeslagen": "Settings saved",
 "Platformcommissie (%)": "Platform commission (%)",
 "Loyaliteitscommissie (%)": "Loyalty commission (%)",
 "Loyaliteit na x opeenvolgende maanden": "Loyalty after x consecutive months",
 "Annuleringstermijn (uren)": "Cancellation window (hours)",
 "Beheer van Onskola": "Onskola administration",
 "Aanmeldingen": "Applications",
 "Boekingen": "Bookings",
 "Sessies": "Sessions",
 "Bypass-alerts": "Bypass alerts",
 "Uitbetalingen": "Payouts",
 "Instellingen": "Settings",
 "E-maillog": "Email log",
 "Docentaanmeldingen": "Teacher applications",
 "Aangemaakt": "Created",
 "Ouder": "Parent",
 "Docent": "Teacher",
 "Niveau": "Level",
 "Vorm": "Format",
 "Rooster": "Schedule",
 "Prijs": "Price",
 "Eiland": "Island",
 "Status": "Status",
 "Type": "Type",
 "Bon": "Receipt",
 "Provider": "Provider",
 "Start": "Start",
 "Bezet": "Taken",
 "Reden": "Reason",
 "Bank": "Bank",
 "Tijd": "Time",
 "Aan": "To",
 "Onderwerp": "Subject",
 "Link": "Link",
 "Quote": "Quote",
 "Lestegoed bijgewerkt.": "Credit updated.",
 "Opgeslagen": "Saved",
 "Geannuleerd.": "Cancelled.",
 "Kind ": "Child ",
 "Les annuleren": "Cancel lesson",
 "Eiland (binnenkort)": "Island (coming soon)",
 "(binnenkort)": "(coming soon)",
 "Sessie kan niet geannuleerd worden": "Session cannot be cancelled",
 "Commissie moet tussen 0 en 100 liggen en loyaliteitscommissie mag niet hoger zijn": "Commission must be between 0 and 100 and loyalty commission cannot be higher",
 "Saldo kan niet negatief worden": "Balance cannot become negative",
 "Ongeldige ouder of bedrag": "Invalid parent or amount",
 "open": "open",
 "Maand ": "Month ",
 "Veelgestelde vragen": "Frequently asked questions",
 "Word docent": "Become a teacher",
 "Zo word je docent": "How to become a teacher",
 "Contactgegevens in profielen en lessen zijn niet toegestaan; alle communicatie en betalingen lopen via het platform.": "Contact details in profiles and lessons are not allowed; all communication and payments go through the platform.",
 "Hoe het werkt": "How it works",
 "Van zoeken tot live meedoen: zo werkt online bijles bij Onskola.": "From searching to joining live: this is how online tutoring works at Onskola.",
 "Geen betaling, geen plek": "No payment, no seat",
 "Je plek wordt pas definitief na een bevestigde betaling. Tijdens het afrekenen houden we je plek 15 minuten vast.": "Your seat is only confirmed after a confirmed payment. During checkout we hold your seat for 15 minutes.",
 "Wekelijkse lessen": "Weekly lessons",
 "Je betaalt per maand, vóór de maand begint. Je ontvangt 7 dagen vooraf een betaallink, met herinneringen 3 en 1 dag vooraf.": "You pay per month, before the month starts. You receive a payment link 7 days in advance, with reminders 3 days and 1 day before.",
 "Betaalbewijs": "Receipt",
 "Na elke betaling ontvang je een betaalbewijs per e-mail. Je kunt ze ook downloaden in je dashboard.": "After every payment you receive a receipt by email. You can also download them in your dashboard.",
 "Wat als ik moet annuleren?": "What if I need to cancel?",
 "Annuleer je meer dan 24 uur voor de les, dan ontvang je lestegoed. Binnen 24 uur ontvang je geen lestegoed.": "If you cancel more than 24 hours before the lesson, you receive credit. Within 24 hours you receive no credit.",
 "Wat als de docent niet komt?": "What if the teacher does not show up?",
 "Annuleert de docent, of is de docent 10 minuten na aanvang niet aanwezig, dan ontvang je automatisch lestegoed.": "If the teacher cancels, or is not present 10 minutes after the start, you automatically receive credit.",
 "Heeft mijn kind een account nodig?": "Does my child need an account?",
 "Nee. Je kind doet mee via jouw account of via een persoonlijke link die alleen voor die les en dat kind werkt.": "No. Your child joins through your account or a personal link that only works for that lesson and that child.",
 "Worden lessen opgenomen?": "Are lessons recorded?",
 "Nee. Alle lessen zijn live en worden niet opgenomen. Je ziet wel de aanwezigheid van je kind per les.": "No. All lessons are live and are not recorded. You can see your child's attendance per lesson.",
 "Extra inkomen": "Extra income",
 "Verdien per kind per les. Maandelijks overzicht en uitbetaling.": "Earn per child per lesson. Monthly overview and payout.",
 "Flexibel": "Flexible",
 "Kies zelf je vakken, lesvormen en tijden.": "Choose your own subjects, formats and times.",
 "Alles ingebouwd": "Everything built in",
 "Live videolessen met schermdelen, direct op het platform.": "Live video lessons with screen sharing, right on the platform.",
 "Professioneel": "Professional",
 "Wij regelen betalingen, aanwezigheid en communicatie.": "We handle payments, attendance and communication.",
 "Geef online bijles bij Onskola": "Teach online at Onskola",
 "Deel je kennis met leerlingen in de Dutch Caribbean. Flexibel, vanuit huis en met de steun van een professioneel platform.": "Share your knowledge with students in the Dutch Caribbean. Flexible, from home and backed by a professional platform.",
 "Meld je aan en accepteer de Algemene Voorwaarden voor Docenten.": "Sign up and accept the Teacher Terms.",
 "Upload je ID, diploma's en verklaring omtrent gedrag (alleen zichtbaar voor ons team).": "Upload your ID, diplomas and certificate of good conduct (only visible to our team).",
 "Wij beoordelen je aanmelding.": "We review your application.",
 "Na goedkeuring maak je lessen aan en ontvang je boekingen.": "After approval you create lessons and receive bookings.",
 "Algemene Voorwaarden voor Ouders": "Parent Terms",
 "Algemene Voorwaarden voor Docenten": "Teacher Terms",
 "Privacybeleid": "Privacy Policy",
 "Versie 1.0": "Version 1.0",
 "Placeholder-tekst. De definitieve juridische tekst volgt.": "Placeholder text. The final legal text will follow.",
 "Betalen met Sentoo ": "Paying with Sentoo ",
 "1. Toepasselijkheid": "1. Applicability",
 "2. Boekingen en betaling": "2. Bookings and payment",
 "3. Annuleringen en lestegoed": "3. Cancellations and credit",
 "4. Gedragsregels": "4. Code of conduct",
 "5. Privacy en gegevens": "5. Privacy and data",
 "6. Slotbepalingen": "6. Final provisions",
 "Deze sectie is een placeholder. Hier komt de definitieve tekst.": "This section is a placeholder. The final text will appear here.",
 "Voordelen": "Benefits",
 "Terug naar dashboard": "Back to dashboard",
 "Deze les is niet meer actief.": "This lesson is no longer active.",
 "Je hebt de les verlaten.": "You have left the lesson.",
 "TESTMODUS – Daily API-sleutel nog niet ingesteld": "TEST MODE – Daily API key not set yet",
 "Opnemen uitgeschakeld": "Recording disabled",
 "Hier verschijnt de Daily Prebuilt video": "The Daily Prebuilt video appears here",
 "Scherm delen": "Share screen",
 "Les verlaten": "Leave lesson",
 "Actief vanaf": "Active from",
 "Deze persoonlijke link werkt alleen voor deze les en voor": "This personal link only works for this lesson and for",
 "(jij)": "(you)",
 "Docent (host)": "Teacher (host)",
 "Je bent de docent (host). Schermdelen staat aan, opnemen is uitgeschakeld.": "You are the teacher (host). Screen sharing is on, recording is disabled.",
 "Les niet gevonden.": "Lesson not found.",
 "Terug naar lessen": "Back to lessons",
 "Alle lessen": "All lessons",
 "Live online, geen opnames": "Live online, no recordings",
 "Geen geplande lessen.": "No scheduled lessons.",
 "Alle tijden in Atlantic Standard Time (Aruba, UTC−4).": "All times in Atlantic Standard Time (Aruba, UTC−4).",
 "Geverifieerde docent": "Verified teacher",
 "per kind per les": "per child per lesson",
 "Er zijn momenteel geen plekken te boeken.": "There are currently no seats available to book.",
 "Alleen ouders kunnen lessen boeken.": "Only parents can book lessons.",
 "kinderen per les": "children per lesson",
 "Vakken": "Subjects",
 "Talen": "Languages",
 "Over jou (bio)": "About you (bio)",
 "Account": "Account",
 "Profiel & uitbetaling": "Profile & payout",
 "Ik ga akkoord met de": "I agree to the",
 "en het": "and the",
 "Aanmelding versturen": "Submit application",
 "Weergavenaam (bijv. Mw. S. de Palm)": "Display name (e.g. Mrs. S. de Palm)",
 "Vertel over je ervaring en manier van lesgeven. Contactgegevens zijn niet toegestaan.": "Tell us about your experience and teaching style. Contact details are not allowed.",
 "Accepteer de Algemene Voorwaarden voor Docenten": "Please accept the Teacher Terms",
 "Kies minimaal één vak, schooltype en taal": "Choose at least one subject, school type and language",
 "Aanmelding ontvangen! Upload nu je documenten.": "Application received! Now upload your documents.",
 "Word docent bij Onskola": "Become a teacher at Onskola",
 "Meld je aan, upload daarna je ID, diploma's en verklaring omtrent gedrag. Na goedkeuring kun je lessen publiceren.": "Sign up, then upload your ID, diplomas and certificate of good conduct. After approval you can publish lessons.",
 "Volledige naam": "Full name",
 "E-mailadres": "Email address",
 "Wachtwoord": "Password",
 "Schooltypes": "School types",
 "Rekeningnummer": "Account number",
 "Tenaamstelling": "Account holder",
 "Welkom terug bij Onskola.": "Welcome back to Onskola.",
 "Accepteer de Algemene Voorwaarden voor Ouders om verder te gaan": "Please accept the Parent Terms to continue",
 "Account aangemaakt! Voeg nu je kind(eren) toe.": "Account created! Now add your child(ren).",
 "Account voor ouders": "Parent account",
 "Maak een account aan, voeg je kinderen toe en boek live bijles. Kinderen hebben geen eigen account nodig.": "Create an account, add your children and book live tutoring. Children do not need their own account.",
 "Hallo": "Hello",
 "Onjuist e-mailadres of wachtwoord": "Incorrect email or password",
 "Te veel pogingen. Probeer het over 15 minuten opnieuw.": "Too many attempts. Try again in 15 minutes.",
 "Dit e-mailadres is al in gebruik": "This email address is already in use",
 "Wachtwoord moet minimaal 8 tekens hebben": "Password must be at least 8 characters",
 "Helaas, deze les is vol": "Sorry, this lesson is full",
 "Deze les of periode is niet (meer) beschikbaar": "This lesson or period is no longer available",
 "Kies een kind": "Choose a child",
 "De reservering is verlopen. Boek opnieuw.": "The reservation has expired. Please book again.",
 "Deze boeking kan niet meer betaald worden": "This booking can no longer be paid",
 "De betaaltermijn is verstreken": "The payment deadline has passed",
 "Deze les kan niet meer geannuleerd worden": "This lesson can no longer be cancelled",
 "Je kunt pas lessen publiceren nadat je aanmelding is goedgekeurd": "You can only publish lessons after your application has been approved",
 "Lesdatums moeten in de toekomst liggen": "Lesson dates must be in the future",
 "Vul het lesrooster volledig in": "Please complete the lesson schedule",
 "Rooster en prijs kunnen niet worden gewijzigd zodra er boekingen zijn": "Schedule and price cannot be changed once there are bookings",
 "De lesruimte opent 10 minuten voor aanvang": "The lesson room opens 10 minutes before the start",
 "Deelnemen kan vanaf 10 minuten voor aanvang tot het einde van de les": "You can join from 10 minutes before the start until the end of the lesson",
 "Deze link is ongeldig": "This link is invalid",
 "Deze link is niet (meer) geldig voor deze les": "This link is not (or no longer) valid for this lesson",
 "Het is even erg druk. Probeer het opnieuw.": "It is very busy right now. Please try again.",
 "Upload een afbeelding": "Please upload an image",
 "Bestand is te groot (max 10 MB)": "File is too large (max 10 MB)",
 "Contactgegevens zijn niet toegestaan op Onskola. Verwijder deze om op te slaan. Gevonden in": "Contact details are not allowed on Onskola. Remove them to save. Found in",
 "Prijs moet groter dan 0 zijn": "Price must be greater than 0",
 "Dit eiland is nog niet beschikbaar": "This island is not available yet",
 "Geen toegang": "No access",
 "telefoonnummer": "phone number",
 "e-mailadres": "email address",
 "website/URL": "website/URL",
 "social media": "social media",
 "Bio": "Bio",
 "Titel:": "Title:",
 "Beschrijving:": "Description:",
 "Er ging iets mis. Probeer het opnieuw.": "Something went wrong. Please try again.",
 "Betaal vóór {d} om je plek te behouden.": "Pay before {d} to keep your seat.",
 "Minder dan {h} uur voor aanvang: je ontvangt GEEN lestegoed. Toch annuleren?": "Less than {h} hours before the start: you will NOT receive credit. Cancel anyway?",
 "Hallo {n}": "Hello {n}",
 "Max. kinderen (max {n})": "Max. children (max {n})",
 "Voorwaarden geaccepteerd: versie {v}": "Terms accepted: version {v}",
 "{n} nieuwe alert(s)": "{n} new alert(s)",
 "Voorwaarden": "Terms",
 "op": "on",
 "Wekelijks op {d} om {t} ({m} min) – per maand te boeken": "Weekly on {d} at {t} ({m} min) – booked per month",
 "Cursusblok van {n} lessen ({m} min) – als één pakket te boeken": "Course block of {n} lessons ({m} min) – booked as one package",
 "Losse les van {m} minuten": "Single lesson of {m} minutes",
 "Wekelijkse reeks": "Weekly series",
 "Cursusblok": "Course block",
 "les(sen)": "lesson(s)",
 "komende lessen": "upcoming lessons",
 "Annulering door ouder": "Cancellation by parent",
 "Annulering door docent": "Cancellation by teacher",
 "Annulering door admin": "Cancellation by admin",
 "Lestegoed gebruikt bij boeking": "Credit used for booking",
 "Plek niet meer beschikbaar na betaling": "Seat no longer available after payment",
 "Handmatige correctie": "Manual adjustment",
 "De startdatum mag niet in het verleden liggen": "The start date cannot be in the past",
 "Betaling ontvangen, log in om je boeking te bekijken.": "Payment received, log in to view your booking.",
 "Je hebt geen toegang tot deze boeking.": "You do not have access to this booking.",
 "Inloggen": "Log in",
 "Betaallink ongeldig": "Invalid payment link",
 "Betaling niet gevonden": "Payment not found",
 "Niet ingelogd": "Not logged in",
 "1-op-1 bijles": "1-on-1 tutoring",
 "Kleine groep": "Small group",
 "Groepsles": "Group class",
 "Examenbootcamp": "Exam bootcamp",
 "Vakantiecursus": "Holiday course",
 "saldo": "balance",
 "komende les": "upcoming lesson",
 "les": "lesson"
};
